import PropTypes from 'prop-types';
import React, { useRef, useState } from 'react';

import { Button } from 'Components';
import { RowView } from 'Containers';
import { ICON_COLOR, POSITION } from 'Constants';
import { mockFunction, useOutsideClick } from 'Helpers';

import './style.scss';

const handleItemClick = ({ isOpen = false, onClick = mockFunction, setIsOpen = mockFunction }) => {
  onClick();
  setIsOpen(!isOpen);
};

const Bubble = ({
  disabled = false,
  icon: Icon,
  items = [],
  label = '',
  loading = false,
  position = 'bottom',
  width = ''
}) => {
  const dropdownRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const poitionRight = position === 'right';
  const filteredItems = items.filter(({ hide }) => !hide);

  useOutsideClick(dropdownRef, () => {
    setIsOpen(false);
  });

  return (
    <div className="dropdown" ref={dropdownRef}>
      <Button
        processing={loading}
        id="button"
        width={width}
        disabled={disabled}
        round
        {...(!loading && { onClick: setIsOpen.bind(null, !isOpen) })}
        className={label ? `${isOpen ? 'btn-primary' : 'btn-secondary'} outline` : ''}>
        <div className={`bubble-label ${isOpen ? 'active' : ''} ${Icon && label ? 'pr-4' : ''}`}>{label}</div>

        <RowView width={'auto'}>{Icon && <Icon fillColor={isOpen ? ICON_COLOR.WHITE : ICON_COLOR.BLUE} />}</RowView>
      </Button>

      {isOpen && (
        <div className={`dropdown-content ${POSITION[position]}`}>
          {filteredItems.map(({ disabled, icon: Icon, label, onClick }, idx) => (
            <div
              className="flex justify-center align-center"
              key={idx}
              {...(!disabled && {
                onClick: handleItemClick.bind(null, { isOpen, onClick, setIsOpen })
              })}>
              {poitionRight && (
                <div className={`bubble-icon ${disabled ? 'icon-disabled' : ''} mr-4`}>
                  {Icon && <Icon fillColor={disabled ? ICON_COLOR.LIGHT_GRAY : ICON_COLOR.BLUE} />}
                </div>
              )}
              <div className={`bubble-items ${disabled ? 'items-disabled' : ''}`}>{label}</div>
              {!poitionRight && (
                <div className={`bubble-icon ${disabled ? 'icon-disabled' : ''} ml-4`}>
                  {Icon && <Icon fillColor={disabled ? ICON_COLOR.LIGHT_GRAY : ICON_COLOR.BLUE} />}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

Bubble.propTypes = {
  disabled: PropTypes.bool,
  icon: PropTypes.any,
  items: PropTypes.array.isRequired,
  label: PropTypes.string,
  loading: PropTypes.bool,
  position: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default Bubble;
